import React from 'react';

export type TitleType = 'normal' | 'bold';
export type LinkItem = {
  linkText: string;
  linkRef: string;
  isPhoneNumber?: boolean;
  shouldOpenInNewTab?: boolean;
}

export interface IconBlockProps {
  title: string;
  titleType?: TitleType;
  icon: string;
  iconType?: string;
  subtitle?: string | JSX.Element;
  linkText?: string;
  linkRef?: string;
  className?: string;
  dataCy?: string;
  dataTestId?: string;
  isPhoneNumber?: boolean;
  useHoverStyles?: boolean;
  onClick?: VoidFunction;
  shouldOpenInNewTab?: boolean;
  isDisabled?: boolean;
  onActionClick?: VoidFunction;
  action?: boolean;
  actionText?: string;
  links?: Array<LinkItem>;
}

export interface LinksProps {
  handleLinkRedirect?: (event: React.MouseEvent<HTMLElement>) => void;
  links?: Array<LinkItem>;
}

interface LinkComponentProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isPhoneNumber?: boolean;
  children: React.ReactNode;
}

const Link = ({ isPhoneNumber, children, className = '', href, target, rel, onClick }: LinkComponentProps) => {
  const colorClasses = isPhoneNumber
    ? 'text-current no-underline'
    : 'text-blue-600';

  return (
    <a
      className={`font-medium text-base leading-[19px] ${colorClasses} ${className}`}
      href={href}
      target={target}
      rel={rel}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

interface LinksContainerProps {
  children: React.ReactNode;
  className?: string;
}

const LinksContainer = ({ children, className = '' }: LinksContainerProps) => (
  <div
    className={`flex justify-start items-center flex-wrap gap-y-[5px] gap-x-8 ${className}`}
  >
    {children}
  </div>
);

export const Links: React.FC<LinksProps> = ({
  handleLinkRedirect,
  links,
}: LinksProps) => (
  <LinksContainer className="links-container" data-testid="links-container">
    {links?.map((link) => (
      <Link
        key={link.linkText}
        className={`link-${link.linkText}`}
        href={link.isPhoneNumber ? `tel:+${link.linkRef}` : link.linkRef}
        isPhoneNumber={link.isPhoneNumber}
        onClick={handleLinkRedirect}
        target={link.shouldOpenInNewTab ? '_blank' : '_self'}
      >
        {link.linkText}
      </Link>
    ))}
  </LinksContainer>
);
